import * as React from "react";
import {useEffect, useState} from "react";
import {Container, MenuItem} from "@mui/material";
import { shipmentInfoStart } from "../../state/actions/ShipmentAction";
import { ActionTypes } from "../../state/constantes/ActionTypes";
import { connect } from "react-redux";
import {shipmentInfoByUserStart} from "../../state/actions/ShipmentByUserAction";
import { portsStart } from "../../state/actions/PortsAction";
import { extractUrlParams } from "../../../../common/utils/Utils";
import "../../style/style.css";
import {Alert} from "@mui/lab";
import {PuiGrid, PuiSection, PuiTextField , PuiButton ,PuiIcon , PuiAutocomplete} from "@portnet/ui";

function SearchForm(props) {

  const [searchForm,setSearchForm]= useState({});
  useEffect(() => {
    let action = shipmentInfoByUserStart({
      type: ActionTypes.ACTION_SHIPMENT_BY_USER_START,
      payload: props.params,
    });

    props.dispatch(action);
  }, []);

  useEffect(() => {
    let actionPorts = portsStart({
      type: ActionTypes.ACTION_PORTS_START,
      payload: extractUrlParams(window.location.href),
    });
    props.dispatch(actionPorts);
  }, []);

  function handleReset() {
    window.location.reload();
  }

  function submitSearch(){
    console.log('container : ' + JSON.stringify(searchForm));
    let action = shipmentInfoStart({
      type: ActionTypes.ACTION_SHIPMENT_START,
      payload: searchForm
          //{ numConteneur: container ,port: port, numReservation: null, numConnaissement:null , eta: null , etd: null},
    });
    props.dispatch(action);

  }

  function handleRetour() {
    window.location.reload();
  }

  return (
      <>
      <PuiSection title="Paramètres de recherche">
        <Alert severity="info" icon={false} style={{margin:0, marginBottom:10}}>
          <ul style={{margin: 0}}>
            <li>Numéro de conteneur + Port + Numéro de réservation
            </li>
            <li>Numéro de conteneur + Port + Numéro de connaissement
            </li>
            <li>Numéro de conteneur + Port + ETA + ETD
            </li>
          </ul>
        </Alert>
        <PuiGrid container spacing={1}>
          <PuiGrid item sm={6} xs={12}>
            <PuiTextField
                formik={false}
                required
                label="Numéro de conteneur"
                name="numConteneur"
                onChange={(newValue) => {setSearchForm( {... searchForm , numConteneur: newValue.target.value})

                }}
            />
          </PuiGrid>
          <PuiGrid item sm={6} xs={12}>
            <PuiAutocomplete
                formik={false}
                fullWidth
                getOptionLabel={(option) => option.label}
                label="Port"
                name="port"
                onChange={(option) => {
                  setSearchForm({... searchForm ,port: option.code})
                }}
                options={props.portList.data}
            />

          </PuiGrid>
          <PuiGrid item sm={6} xs={12}>
            <PuiTextField
                formik={false}
                label="Numéro de réservation"
                name="numReservation"
                onChange={(newValue) => {
                  setSearchForm({... searchForm, 'numReservation': newValue.target.value})
                }}
            />
          </PuiGrid>
          <PuiGrid item sm={6} xs={12}>
            <PuiTextField
                formik={false}
                label="Numéro de connaissement"
                name="numConnaissement"
                onChange={(newValue) => {
                  setSearchForm({... searchForm ,'numConnaissement': newValue.target.value})
                }}
            />
          </PuiGrid>
          <PuiGrid item sm={6} xs={12}>
            <PuiTextField
                formik={false}
                label="ETA"
                name="eta"
                type="date"
                format={"YYYY-MM-DD"}
                onChange={(newValue) => {
                  setSearchForm({... searchForm ,'eta': newValue.target.value})
                }}
            />
          </PuiGrid>
          <PuiGrid item sm={6} xs={12}>
            <PuiTextField
                formik={false}
                label="ETD"
                name="etd"
                type="date"
                format={"YYYY-MM-DD"}
                onChange={(newValue) => {
                  console.log(newValue)
                  setSearchForm({... searchForm ,'etd': newValue.target.value})
                }}
            />
          </PuiGrid>
        </PuiGrid>
        <PuiGrid
            container
            justifyContent="flex-end"
            spacing={1}
            sx={{ marginTop: 2 }}
        >
          <PuiGrid item>
            <PuiButton
                onClick={() => handleReset()}
                color="tertiary"
                startIcon={<PuiIcon type="effacer" />}
            >
              Effacer
            </PuiButton>
          </PuiGrid>
          <PuiGrid item>
            <PuiButton
               onClick={submitSearch}

                startIcon={<PuiIcon type="rechercher" />}>
              Rechercher
            </PuiButton>
          </PuiGrid>
        </PuiGrid>
      </PuiSection>
      </>
  );
}

const mapStateToProps = (state) => {
  return { ...state, portList: state.PortsReducer };
};

export default connect(mapStateToProps, null)(SearchForm);
